import { useEffect } from 'react';
import type { ReactNode } from 'react';

export interface AppModalProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  /** Defaults to the standard 460px modal width used across confirmation dialogs. */
  maxWidthClassName?: string;
}

// Generic centered modal overlay - escape and click-outside both close it.
const AppModal = ({
  open,
  onClose,
  children,
  maxWidthClassName = 'max-w-[460px]',
}: AppModalProps) => {
  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-navy/55 p-6"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className={`w-full ${maxWidthClassName} max-h-[90vh] overflow-y-auto rounded-[22px] bg-white p-7 shadow-[0_24px_70px_rgba(0,29,47,0.35)]`}
      >
        {children}
      </div>
    </div>
  );
};

export default AppModal;
